var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"mb-2",attrs:{"id":"citizenship","label":((_vm.$t('Administration.staff.form.post.label')) + "*"),"label-for":"citizenship"}},[_c('v-select',{staticClass:"rounded",class:{
      'border border-success': _vm.role,
      'border border-danger': !_vm.role,
    },attrs:{"options":_vm.roleList,"placeholder":_vm.post,"label":"title"},on:{"input":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }